(ns teamoesterreich.firebase.auth
  (:require
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.provider :as provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.util.cookies :as cookies]
    [teamoesterreich.util.log :as log]
    )
  (:use-macros [cljs.core.async.macros :only [go]]))



(defn login-fb [session]
  (let [auth (.auth js/firebase)]
    (.then (.setPersistence auth js/firebase.auth.Auth.Persistence.LOCAL)
           (fn [_]
             (doto (.signInWithCustomToken auth session)
               (.catch (fn [e]
                         (js/console.error "try login FAILED!!" e)
                         nil))
               (.then
                 (fn [^js login-result]
                   (log/out "try login " login-result)
                   login-result
                   )))))))

(defn update-device [userId]
  (when userId
    (log/out "update device " userId)
    (provider/update-fs-user (clj->js {:active true}))
    (provider/update-fs-device (clj->js {:app-version config/BUILD_DATE
                                         :serial      "browser"
                                         :timestamp   (js/Date.)
                                         :type        "BROWSER"}))))

(defn logout []
  (.then (.signOut (.auth js/firebase))
         (fn [_]
           (cookies/clear!)
           (store/reset)
           nil)))


(def !auth-listener (atom nil))

(defn set-auth-listener []
  (when-let [unsubscribe @!auth-listener] (unsubscribe))
  (log/out "set-auth-listener")
  (let [auth (js/firebase.auth)]
    (reset! !auth-listener
            (.onAuthStateChanged auth
                                 (fn [user]
                                   ;(log/out "firebase onAuthStateChanged called" user)
                                   (if user
                                     (let [userId (.-uid user)]
                                       (log/out "firebase onAuthStateChanged " userId)
                                       (swap! store/app-state assoc :firebase-uid userId)
                                       (update-device userId)
                                       (provider/remove-fs-to-store-list-listeners "/")
                                       (provider/connect-fs userId))

                                     (do
                                       (log/out "firebase onAuthStateChanged OUT")
                                       (swap! store/app-state assoc :firebase-uid nil)
                                       (provider/remove-fs-to-store-list-listeners "/")
                                       (-> (.signInAnonymously auth)
                                           (.catch (fn [e] (log/out "try login FAILED!!" e)))
                                           (.then
                                             (fn [^js login-result]
                                               (log/out "try login anon " login-result)
                                               (let [userId (.-uid (.-user login-result))]
                                                 (update-device userId))
                                               ))))))))
    ))


;""cgurKUFO3QPIsIi43KKUx7ZxEuG2""
;(.-uid (.-currentUser (.auth js/firebase)))
;(log/out (.-currentUser (.auth js/firebase)))


;(login-anonymous)







